module.exports = __webpack_public_path__ + "img/projects.f9fc606f.svg";